import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DOCUMENT_API_URL } from '../constants';
import { IDocumentReferenceProductDTO } from '../model';

@Injectable()
export class DocumentReferenceApiService {
  private get getBaseUrl(): string {
    return `${this.documentApiUrl}/api/DocumentReference`;
  }

  private readonly http = inject(HttpClient);
  private readonly documentApiUrl = inject(DOCUMENT_API_URL);

  getDocumentTypes(
    tenantLobProductId: string,
    reference: string,
    filter?: string
  ): Observable<IDocumentReferenceProductDTO[]> {
    const url = `${this.getBaseUrl}/GetDocumentTypes/tenantLobProduct/${tenantLobProductId}/reference/${reference}`;
    return this.http.get<IDocumentReferenceProductDTO[]>(filter ? `${url}?filter=${filter}` : url);
  }
}
